import React, { createContext, useCallback, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

// Context value type
type NavigationContextType = {
  navigate: (to: string, options?: any) => void;
  navigationInProgress: () => boolean;
};

const NavigationContext = createContext<NavigationContextType | undefined>(
  undefined,
);

export const NavigationProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const navigationInProgressRef = useRef(false);
  const realNavigate = useNavigate();

  const navigate = useCallback(
    (to: string, options?: any) => {
      if (!navigationInProgressRef.current) {
        navigationInProgressRef.current = true;
        realNavigate(to, options);
      }
    },
    [realNavigate],
  );

  const navigationInProgress = useCallback(
    () => navigationInProgressRef.current,
    [],
  );

  return (
    <NavigationContext.Provider value={{ navigate, navigationInProgress }}>
      {children}
    </NavigationContext.Provider>
  );
};

export function useNavigation() {
  const ctx = useContext(NavigationContext);
  if (!ctx)
    throw new Error('useNavigation must be used within a NavigationProvider');
  return ctx;
}
